import ColoredBall from '@/components/icon/ColoredBall';
import React, { HTMLProps, Ref, useState } from 'react';
import { Override, filterDOMProps, useForm } from 'uniforms';

export type SubmitFieldProps = Override<
  HTMLProps<HTMLButtonElement>,
  { inputRef?: Ref<HTMLButtonElement>; value?: string }
>;

export default function SubmitField({
  disabled,
  inputRef,
  readOnly,
  value,
  ...props
}: SubmitFieldProps) {
  const { error, state } = useForm();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      data-test-id="submit-field"
      {...filterDOMProps(props)}
      type="submit"
      {...(value ? { value } : {})}
      ref={inputRef}
      disabled={disabled === undefined ? !!(error || state.disabled) : disabled}
      className="my-6 inline-flex h-[50px] w-full items-center justify-center gap-2.5 rounded-[100px] bg-indigo-950 px-[25px] py-2.5 text-white hover:bg-[#18153c] disabled:opacity-50 lg:w-fit"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {value}
      {isHovered ? <ColoredBall animated /> : <span className="w-2" />}
    </button>
  );
}
